module.exports = __webpack_public_path__ + "static/img/H5SCONSOLE@2x.441a19a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/gallery/H5SCONSOLE@2x.png
// module id = zy2A
// module chunks = 1